import { render, staticRenderFns } from "./ShareCommentPolicy.vue?vue&type=template&id=2bf8816d&scoped=true"
import script from "./ShareCommentPolicy.vue?vue&type=script&lang=ts"
export * from "./ShareCommentPolicy.vue?vue&type=script&lang=ts"
import style0 from "./ShareCommentPolicy.vue?vue&type=style&index=0&id=2bf8816d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf8816d",
  null
  
)

export default component.exports